import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './OpenMediaModalButton.styled';

const OpenMediaModalButton = (props) => {
  return <Styled.OpenMediaModalButton onClick={props.onClick} />;
};

OpenMediaModalButton.propTypes = {
  onClick: PropTypes.func,
};

export default OpenMediaModalButton;
